/* eslint-disable import/prefer-default-export */
import PropTypes from "prop-types";

export const FormPropTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  dirty: PropTypes.bool.isRequired
};
